import { LuAsterisk } from "react-icons/lu";

export const Required = () => {
  return <LuAsterisk className="inline align-top text-zinc-700	" />;
};
